const projectPage = {
  loading: "Hleð verkefni...",
  errorTitle: "Villa við að hlaða verkefni",
  errors: {
    failedToLoadProject: "Ekki tókst að hlaða verkefni",
    downloadFailed: "Niðurhal mistókst",
    failedToRemoveUser: "Ekki tókst að fjarlægja notanda",
    failedToChangeArchiveState: "Ekki tókst að breyta skjalasöfnunarstöðu",
    failedToDisable2FA: "Ekki tókst að slökkva á tvíþátta auðkenningu",
    failedToRevokeInvitation: "Ekki tókst að afturkalla boð",
  },
  alerts: {
    unenrolled: "Þú hefur verið fjarlægð(ur) úr þessu verkefni.",
  },
  confirm: {
    revokeInvitation: "Afturkalla þetta boð?",
  },
  header: {
    backToProjects: "Til baka í verkefni",
  },
  badges: {
    viewOnly: "Aðeins skoðun",
    archived: "Í skjalasafni",
    active: "Virkt",
    inactive: "Óvirkt",
  },
  archivedNote: {
    text: "Þetta verkefni er óvirkt og er því í skrifvörðum ham.",
    restoreLink: "Endurvirkjaðu það í stillingum",
  },
  meta: {
    organizationId: "Auðkenni stofnunar",
    yourRole: "Hlutverk þitt",
    managerViewOnly: "Yfirmaður (aðeins skoðun)",
  },
  tabs: {
    overview: "Yfirlit",
    members: "Meðlimir",
    datasets: "Gagnasöfn",
    requests: "Gagnabeiðnir",
  },
  overview: {
    teamMembers: "Meðlimir teymis",
    datasets: "Gagnasöfn",
    dataRequests: "Gagnabeiðnir",
    fulfilled: "afgreiddar",
    needsAttention: "Þarfnast athygli",
    allReviewed: "Ekkert í bið — allar beiðnir yfirfarnar",
    requestedOn: "Beðið um {{date}}",
    review: "Yfirfara",
  },
  members: {
    createdBy: "Stofnað af",
    you: "þér",
    formerMember: "meðlim sem er ekki lengur í verkefninu",
    noMembers: "Engir meðlimir skráðir í þetta verkefni",
  },
  datasets: {
    title: "Gagnasöfn verkefnis",
    subtitle: "Gagnasöfn hlaðið upp eða samþykkt fyrir þetta verkefni",
    uploadButton: "Hlaða upp gagnasafni",
    uploadPanelTitle: "Hlaða gagnasafni upp í verkefni",
    uploadPanelSubtitle: "Hlaða upp gagnaskrám fyrir þetta verkefni og fjarlægja auðkenni úr þeim",
    uploadSuccess: "Skrá hlaðin upp.",
  },
  requests: {
    title: "Gagnabeiðnir verkefnis",
    newRequest: "Ný beiðni",
  },
};

export default projectPage;
